module.exports = __webpack_public_path__ + "img/mingyong46.1b6fa528.png";